// extracted by mini-css-extract-plugin
export default {"img":"header1_img__mZ-Me","title":"header1_title__ZPrPd","description":"header1_description__8cfWE"};